import React, { useState } from "react";
// react component for creating dynamic tables
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
//import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import ReactBSAlert from "react-bootstrap-sweetalert";
import { useAsyncEffect } from "use-async-effect";
import { useRef } from "react"; 
import DatePicker from "react-datepicker";
import FormControl from "@material-ui/core/FormControl";
import ToolkitProvider, {
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import formsComponentStyles from "assets/theme/components/forms.js";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import Collapse from "@material-ui/core/Collapse";
import Container from "@material-ui/core/Container";
import Divider from "@material-ui/core/Divider";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import FilterList from "@material-ui/icons/FilterList";
import AddIcon from "@material-ui/icons/Add";
import GetApp from "@material-ui/icons/GetApp";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import FormGroup from "@material-ui/core/FormGroup";
import FormLabel from "@material-ui/core/FormLabel";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import ClearIcon from '@material-ui/icons/Clear';
// @material-ui/lab components
// @material-ui/icons components
// core components
import Snackbar from "components/Snackbar/Snackbar.js";
import componentStyles from "assets/theme/views/admin/react-bs-table.js";
import btnComponentStyles from "assets/theme/components/button.js";
import LoadingAnimation from "components/Animations/loading";
import Slide from "@material-ui/core/Slide";
import {
  redirectToLogout,
  numericSortFunc,
  dateSortFunc,
} from "common/SharedFn";
import {
  getAllComplaints,
  updateComplaint,
  addComplaint,
} from "../../network/ApiAxios";
import { Edit } from "@material-ui/icons";
import "react-datepicker/dist/react-datepicker.css";
import { MenuItem } from "@material-ui/core";
import Select from "@material-ui/core/Select";
import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown";

const useStyles = makeStyles(componentStyles);
const useStylesButtons = makeStyles(btnComponentStyles);
const useStylesForms = makeStyles(formsComponentStyles);

const createHistory = require("history").createBrowserHistory;

const pagination = paginationFactory({
  page: 1,
  alwaysShowAllBtns: true,
  showTotal: true,
  withFirstAndLast: false,
  sizePerPage: 50,
  sizePerPageRenderer: ({ onSizePerPageChange }) => (
    <div className="dataTables_length" id="datatable-basic_length">
      <label>
        Show{" "}
        {
          <select
            name="datatable-basic_length"
            aria-controls="datatable-basic"
            className="form-control form-control-sm"
            onChange={(e) => onSizePerPageChange(e.target.value)}
          >
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="1000">1000</option>
          </select>
        }{" "}
        entries.
      </label>
    </div>
  ),
});

const { SearchBar } = Search;

const { ExportCSVButton } = CSVExport;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const ComplaintsTable = (props) => {
  const classes = {
    ...useStyles(),
    ...useStylesButtons(),
    ...useStylesForms(),
  };
  const [alert, setAlert] = React.useState(false);
  const componentRef = React.useRef(null);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState("");
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [activeOnly, setActiveOnly] = useState(1);
  const [notifMessage, setNotifMessage] = useState("");
  const [showError, setShowError] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const [addModal, setAddModal] = useState(false);
  const [category, setCategory] = useState("");
  const [description, setDescription] = useState("");
  const [orderId, setOrderId] = useState("");
  const [userId, setUserId] = useState("");
  const [compensationValue, setCompensationValue] = useState("");
  const [complaintStatus, setComplaintStatus] = useState("");
  const [comment, setComment] = useState("");
  const [images, setImages] = useState([]);
  const [imageUploadFiles, setImageUploadFiles] = useState([]);
  const fileInputRef = useRef(null);
  const [id, setId] = useState();
  const [executeUpdate, setExecuteUpdate] = useState(false);
  const [forceRefresh, setForceRefresh] = useState(false);
  // Filters are hidden behind a toggle rather than always occupying a row of
  // their own -- most visits don't change them, and the row read as empty space.
  const [showFilters, setShowFilters] = useState(false);

  const categoriesList = [
    { value: 0, name: "Delivery" },
    { value: 1, name: "Stains" },
    { value: 2, name: "Pressing" },
    { value: 3, name: "Smell" },
    { value: 4, name: "Damage" },
    { value: 5, name: "Misplaced/Missing Items" },
    { value: 6, name: "Instructions wasn't followed" },
  ];
  
  const statusesList = [
    { value: 0, name: "Pending" },
    { value: 1, name: "In Progress" },
    { value: 2, name: "Resolved" },
    { value: 3, name: "Case Closed" },
    { value: 4, name: "Re Opened" },
    { value: 5, name: "All" },
  ];

  const statusesListBackend = [
    { value: 0, name: "PENDING" },
    { value: 1, name: "IN_PROGRESS" },
    { value: 2, name: "RESOLVED" },
    { value: 3, name: "CASE_CLOSED" },
    { value: 4, name: "REOPENED" },
  ];

  const getCategoryName = (categoryValue) => {
    const category = categoriesList.find((cat) => cat.value === categoryValue);
    return category ? category.name : "";
  };
  
  const getStatusName = (statusName) => {
    const status = statusesListBackend.find((status) => status.name === statusName);
    return status ? statusesList[status.value].name : "";
  };

  const validateFields = () => {
    if (!orderId || !userId || !description) {
      showErrorNotification("Order ID, User ID, and Description are required fields.");
      return false;
    }
    return true;
  };

  const warningAlert = (title, message, action) => {
    setAlert(
      <ReactBSAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title={title}
        onConfirm={action}
        onCancel={() => setAlert(null)}
        showCancel="true"
        cancelBtnBsStyle="warning"
        cancelBtnText="No"
        confirmBtnBsStyle="success"
        confirmBtnText="Yes"
        btnSize=""
        confirmBtnStyle={{
          marginRight: undefined,
          borderColor: undefined,
          boxShadow: undefined,
        }}
        cancelBtnStyle={{
          marginRight: undefined,
          borderColor: undefined,
          boxShadow: undefined,
        }}
      >
        {message}
      </ReactBSAlert>
    );
  };

  const showSuccessNotification = (message) => {
    setNotifMessage(message);
    setSuccess(true);
    setTimeout(function () {
      setSuccess(false);
    }, 3000);
  };

  const showErrorNotification = (message) => {
    setNotifMessage(message);
    setShowError(true);
    setTimeout(function () {
      setShowError(false);
    }, 3000);
  };

  const setCurrentRecord = (info) => {
    const {
      id,
      imageUrls,
      compensationValue,
      comment,
      status,
    } = info;
  
    setId(id);
    setImages(imageUrls);
    setCompensationValue(compensationValue);
    setComment(comment);
  
    const selectedStatus = statusesListBackend.find((statusItem) => statusItem.name === status);
    if (selectedStatus) {
      setComplaintStatus(selectedStatus.value);
    } else {
      setComplaintStatus("");
    }
  };
  
  const clearCurrentRecord = () => {
    setId("");
    setCategory(0);
    setDescription("");
    setCompensationValue("");
    setComplaintStatus(0);
    setOrderId("");
    setUserId("");
    setComment("");
    setImages([]);
    setImageUploadFiles([]);
    fileInputRef.current.value = null;
  };

  // add complaint
  const addComplaintAction = async () => {
    if (!validateFields()) {
      return; // Exit if validation fails
    }
    setIsLoading(true);
    try {
      const categoryName = getCategoryName(category); 
      const response = await addComplaint(
        categoryName,
        description,
        orderId,
        userId,
        0,
        compensationValue, 
        comment,
        imageUploadFiles,
      );
      const { data } = response;
      if (data.result.isSuccess) {
        showSuccessNotification("Complaint Added Successfully");
        setAddModal(false);
        setForceRefresh(true);
      } else {
        showErrorNotification(data.result.description);
        setIsLoading(false);
      }
    } catch (ex) {
      showErrorNotification("Failed to add complaint");
      setIsLoading(false);
    }
  };

  // update complaint
  const updateComplaintAction = async () => {
    setExecuteUpdate(false);
    setIsLoading(true);
    try {
      const updatedBy = localStorage.getItem("username");
      const response = await updateComplaint(
        id,
        images,
        complaintStatus,
        compensationValue ?? 0,
        comment,
        updatedBy
      );
      const { data } = response;
      console.log(data);
      if (data.result.isSuccess) {
        showSuccessNotification("Complaint Updated Successfully");
        setAddModal(false);
        setForceRefresh(true);
      } else {
        showErrorNotification(data.result.description);
        setIsLoading(false);
      }
    } catch (ex) {
      showErrorNotification("Failed to update complaint");
      setIsLoading(false);
    }
  };

  const fetchComplaints = async () => {
    setForceRefresh(false);
    setIsLoading(true);
    try {
      const response = await getAllComplaints(startDate, endDate, activeOnly);
      const { data } = response;
      if (data.result.isSuccess) {
        setData(data.data.map((prop) => makeTableRow(prop)));
        console.log(data.data);
      } else {
        showErrorNotification(data.result.description);
        if (data.result.code == -2) {
          redirectToLogout();
        }
      }
    } catch (ex) {
      showErrorNotification("Failed to fetch comlpaints");
    }
    setIsLoading(false);
  };

    // Handle image change
    const handleImageChange = (e) => {
      const files = Array.from(e.target.files);
      const promises = files.map((file) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
        });
      });
      Promise.all(promises)
    .then((base64Images) => {
      setImages((prevImages) => [...prevImages, ...base64Images]); // Append new images to existing images
      setImageUploadFiles((prevFiles) => [...prevFiles, ...files]); // Append new files to existing files
    })
    .catch((error) => {
      console.error('Error converting files to base64:', error);
    });
    };
    

    // Remove image
    const removeImage = (index) => {
      const newImages = [...images];
      newImages.splice(index, 1);
      setImages(newImages);
      const newFiles = [...imageUploadFiles];
      newFiles.splice(index, 1);
      setImageUploadFiles(newFiles);
    };

  useAsyncEffect(async () => {
    if (executeUpdate) {
      updateComplaintAction();
    }
    if (endDate == null) {
      var endDateStored = localStorage.getItem("searchEndDate");
      if (endDateStored != null && endDateStored.toUpperCase() !== "NULL") {
        setEndDate(new Date(endDateStored));
      } else {
        setEndDate(new Date());
      }
    }
    if (startDate == null) {
      var startDateStored = localStorage.getItem("searchStartDate");
      if (startDateStored != null && startDateStored.toUpperCase() !== "NULL") {
        setStartDate(new Date(startDateStored));
      } else {
        setStartDate(new Date().setDate(new Date().getDate() - 7));
      }
    }
    var searchActiveOnly = localStorage.getItem("searchActiveOnly");
    if (searchActiveOnly != null && searchActiveOnly.toUpperCase() !== "NULL") {
      setActiveOnly(searchActiveOnly);
    }
    if (startDate != null && endDate != null && activeOnly != null) {
      fetchComplaints();
    }
  }, [executeUpdate, forceRefresh, startDate, endDate, activeOnly]);

  const makeTableRow = (info) => {

    return {
      ...info,
      actions: (
        <div className="actions-right">
          <Tooltip title="Edit">
            <Button
              size="small"
              classes={{
                root: classes.buttonContainedWarning,
              }}
              variant="contained"
              style={{
                marginLeft: "5px",
              }}
              onClick={() => {
                setCurrentRecord(info);
                setAddModal(true);
              }}
            >
              <Box component={Edit} />
            </Button>
          </Tooltip>
        </div>
      ),
    };
  };
  return (
    <>
      {alert}
      {/* Page content */}
      <Container
        maxWidth={false}
        component={Box}
        marginTop="-4.5rem"
        classes={{ root: classes.containerRoot }}
      >
        <Grid container>
          <Grid item xs={12}>
            <Card elevation={0}>
              {/* The page title lives in the toolbar row below rather than in
                  its own CardHeader, so it shares a line with the buttons and
                  the search field. It can't go the other way round -- the
                  SearchBar needs ToolkitProvider's render props, which only
                  exist inside it. */}
              <div style={{ width: "100%" }}>
                <ToolkitProvider
                  data={data}
                  keyField="complaintId"
                  columns={[
                    {
                      dataField: "complaintId",
                      text: "ID",
                      sort: true,
                    },
                    {
                      dataField: "orderPublicId",
                      text: "Order ID",
                      sort: true,
                    },
                    {
                      dataField: "userId",
                      text: "User ID",
                      sort: true,
                    },
                    {
                      dataField: "category",
                      text: "Category",
                      sort: true,
                    },
                    {
                      dataField: "description",
                      text: "Description",
                      sort: true,
                    },
                    {
                      dataField: "imageUrls",
                      text: "Images",
                      formatter: (cell, row) => (
                        <div>
                          {cell && cell.length > 0 ? (
                            cell.map((image, index) => (
                              <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '5px', marginTop: '5px' }}>
                                <a href={image} target="_blank" rel="noopener noreferrer">
                                  <img src={image} alt={`Uploaded ${index}`} style={{ maxWidth: '100px', maxHeight: '100px', marginRight: '10px' }} />
                                </a>
                              </div>
                            ))
                          ) : (
                            <div>No images available</div>
                          )}
                        </div>
                      ),
                      csvExport: false,
                    },
                    {
                      dataField: "laundryName",
                      text: "Laundry",
                      sort: true,
                    },
                    {
                      dataField: "datePickedFromLaundryText",
                      text: "Date Washed",
                      sort: true,
                      sortFunc: dateSortFunc,
                    },
                    {
                      dataField: "compensationValue",
                      text: "Compensation Value",
                      sort: true,
                      sortFunc: numericSortFunc,
                    },
                    {
                      dataField: "status",
                      text: "Status",
                      sort: true,
                      formatter: (cell) => getStatusName(cell),
                    },
                    {
                      dataField: "comment",
                      text: "Comment",
                      sort: true,
                    },
                    {
                      dataField: "createdAtText",
                      text: "Created At",
                      sort: true,
                      sortFunc: dateSortFunc,
                    },
                    {
                      dataField: "lastModifiedAtText",
                      text: "Last Modified At",
                      sort: true,
                      sortFunc: dateSortFunc,
                    },
                    {
                      dataField: "updatedBy",
                      text: "Updated By",
                      sort: true,
                    },
                    {
                      dataField: "actions",
                      classes: "actions-col",
                      headerClasses: "actions-col",
                      text: "Actions",
                      csvExport: false,
                    },
                  ]}
                  search
                  exportCSV
                >
                  {(props) => (
                    <>
                    {/* Title and controls go in a real CardHeader, exactly like
                        every other page -- that is where the app's heading inset
                        comes from (theme MuiCardHeader: 1.25rem 1.5rem). Padding
                        this row by hand never matched, and because the row lived
                        inside .table-responsive its right padding fell beyond the
                        table's scroll width, so the filter button sat flush to
                        the edge. Sitting outside the scroller fixes both ends.

                        It has to be inside ToolkitProvider's render function:
                        the SearchBar needs its props. */}
                    <CardHeader
                      title={
                        <Box display="flex" alignItems="center" style={{ gap: 12 }}>
                          <Box
                            component={Typography}
                            variant="h2"
                            marginBottom="0!important"
                          >
                            <Box component="span">Complaints</Box>
                          </Box>
                          {/* Create sits with the thing it creates. */}
                          <Tooltip title="Add new Complaint">
                            <IconButton
                              size="small"
                              onClick={() => {
                                clearCurrentRecord();
                                setAddModal(true);
                              }}
                              style={{
                                width: 32,
                                height: 32,
                                backgroundColor: "#fff",
                                border: "1px solid #5e72e4",
                                color: "#5e72e4",
                              }}
                            >
                              {/* The theme pins MuiSvgIcon to 14x14 via
                                  width/height, which overrides font-size --
                                  so this has to be sized the same way. */}
                              <AddIcon style={{ width: 18, height: 18 }} />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      }
                      action={
                        // CardHeader's action slot is pulled -8px up and right
                        // and top-aligned; undo that so the controls centre on
                        // the title and keep the header's own right padding.
                        <Box
                          display="flex"
                          alignItems="center"
                          flexWrap="wrap"
                          justifyContent="flex-end"
                          style={{ gap: 8, marginTop: 8, marginRight: 8 }}
                        >
                          <div
                            id="datatable-basic_filter"
                            style={{ display: "flex", alignItems: "center", height: 40 }}
                          >
                            <SearchBar
                              className="form-control-sm"
                              placeholder="Search..."
                              style={{
                                height: 40,
                                margin: 0,
                                boxSizing: "border-box",
                              }}
                              {...props.searchProps}
                            />
                          </div>
                          <Tooltip title="Download CSV">
                            <span style={{ display: "flex" }}>
                              <ExportCSVButton
                                className="MuiButtonBase-root"
                                style={{
                                  width: 40,
                                  height: 40,
                                  padding: 0,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  border: "1px solid #172b4d",
                                  borderRadius: 8,
                                  color: "#fff",
                                  backgroundColor: "#172b4d",
                                  cursor: "pointer",
                                }}
                                {...props.csvProps}
                              >
                                <GetApp fontSize="small" />
                              </ExportCSVButton>
                            </span>
                          </Tooltip>
                          <Tooltip title={showFilters ? "Hide filters" : "Filters"}>
                            <IconButton
                              onClick={() => setShowFilters((open) => !open)}
                              aria-expanded={showFilters}
                              aria-label="Filters"
                              style={{
                                width: 40,
                                height: 40,
                                border: "1px solid #dee2e6",
                                borderRadius: 8,
                                color: showFilters ? "#5e72e4" : "#525f7f",
                                backgroundColor: showFilters ? "#eef0fb" : "transparent",
                              }}
                            >
                              <FilterList fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      }
                    />

                    {/* Filter panel -- opened on request, so the page doesn't
                        carry a mostly-empty row. Outside the scroller too, so it
                        keeps the header's gutters. */}
                    <Collapse in={showFilters}>
                      <Divider />
                      <Box
                        component="form"
                        display="flex"
                        alignItems="center"
                        flexWrap="wrap"
                        style={{ gap: 12, padding: "1rem 1.5rem" }}
                      >
                        <Typography variant="body2" color="textSecondary">
                          From
                        </Typography>
                        <DatePicker
                          timeCaption="Start Date"
                          selected={startDate}
                          customInput={<OutlinedInput />}
                          onChange={(date) => {
                            localStorage.setItem("searchStartDate", date);
                            setStartDate(date);
                          }}
                          dateFormat="dd-MM-yyyy"
                          portalId="root-portal"
                        />
                        <Typography variant="body2" color="textSecondary">
                          to
                        </Typography>
                        <DatePicker
                          timeCaption="End Date"
                          selected={endDate}
                          customInput={<OutlinedInput />}
                          onChange={(date) => {
                            localStorage.setItem("searchEndDate", date);
                            setEndDate(date);
                          }}
                          dateFormat="dd-MM-yyyy"
                          portalId="root-portal"
                        />
                        <Select
                          variant="outlined"
                          value={activeOnly}
                          onChange={(e) => {
                            localStorage.setItem("searchActiveOnly", e.target.value);
                            setActiveOnly(e.target.value);
                          }}
                          IconComponent={KeyboardArrowDown}
                        >
                          {statusesList.map((statusItem) => (
                            <MenuItem key={statusItem.value} value={statusItem.value}>
                              {statusItem.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </Box>
                    </Collapse>

                    <div className="table-responsive">
                      <BootstrapTable
                        ref={componentRef}
                        {...props.baseProps}
                        bootstrap4={true}
                        pagination={pagination}
                        bordered={true}
                        striped={true}
                        rowStyle={(row) => {
                          const createdAtDate = new Date(row.createdAtText);
                          const currentDate = new Date();
                          const diffHours = Math.abs((currentDate - createdAtDate) / (1000 * 60 * 60));
                          const statusIndex = statusesListBackend.findIndex((status) => status.name === row.status);
                          if (diffHours > 48 && statusIndex !== 2 && statusIndex !== 3) {
                            return { backgroundColor: '#ffcccc' }; 
                          }
                          return {};
                        }}
                        //filter={ filterFactory() }
                        noDataIndication={() =>
                          isLoading ? (
                            <Box
                              component={Grid}
                              container
                              justifyContent="center"
                              className="justify-content-center"
                            >
                              <div
                                className="text-center"
                                style={{ width: "20%" }}
                              >
                                <LoadingAnimation />{" "}
                              </div>
                            </Box>
                          ) : (
                            <h4>No Records</h4>
                          )
                        }
                        id="main-table"
                      />
                    </div>
                    </>
                  )}
                </ToolkitProvider>
              </div>
            </Card>
          </Grid>
        </Grid>
        <Dialog
          classes={{
            root: classes.center + " " + classes.modalRoot,
            paper: classes.modal + " " + classes.modalSmall,
          }}
          open={addModal && !isLoading}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => setAddModal(false)}
        >
          <DialogTitle disableTypography className={classes.modalHeader}>
            <h4 className={classes.modalTitle}>
              {id == null || id === "" ? "Add" : "Edit"} Complaint
            </h4>
          </DialogTitle>
          <DialogContent
            className={classes.modalBody + " " + classes.modalSmallBody}
          >
            <form>
            {id == null || id === "" ? <FormGroup>
                <FormLabel>Category</FormLabel>
                <FormControl variant="outlined" fullWidth>
                <Select
                  value={category}
                  onChange={(e) => setCategory(e.target.value)}
                  IconComponent={KeyboardArrowDown}
                >
                  {categoriesList.map((cat) => (
                    <MenuItem key={cat.value} value={cat.value}>
                      {cat.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              </FormGroup> : ''}
              {id == null || id === "" ? <FormGroup>
                <FormLabel>Description</FormLabel>
                <OutlinedInput
                  fullWidth
                  type="textarea"
                  placeholder="Description"
                  value={description ?? ""}
                  multiline={true}
                  rows={5}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </FormGroup>: '' }
              {id == null || id === "" ? <FormGroup> 
              <FormLabel>Images</FormLabel>
            <input
              type="file"
              multiple
              ref={fileInputRef}
              onChange={handleImageChange}
            />
            <div>
              {images.map((image, index) => (
                <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '5px', marginTop: '5px' }}>
                  <img src={image} alt={`Uploaded ${index}`} style={{ maxWidth: '100px', maxHeight: '100px', marginRight: '10px' }} />
                  <ClearIcon
                    style={{ cursor: 'pointer' }}
                    onClick={() => removeImage(index)}
                  />
                </div>
              ))}
            </div>
          </FormGroup> : '' }
              {id == null || id === "" ? <FormGroup>
                <FormLabel>Order ID (Including P)</FormLabel>
                <OutlinedInput
                  fullWidth
                  type="text"
                  placeholder="Order Id"
                  value={orderId ?? ""}
                  onChange={(e) => setOrderId(e.target.value)}
                />
              </FormGroup> : ''}
              {id == null || id === "" ? <FormGroup>
                <FormLabel>User ID (Including C)</FormLabel>
                <OutlinedInput
                  fullWidth
                  type="text"
                  placeholder="User Id"
                  value={userId ?? ""}
                  onChange={(e) => setUserId(e.target.value)}
                />
              </FormGroup> : ''}
              {id != null && id !== "" ? <FormGroup>
                <FormLabel>Status</FormLabel>
                <FormControl variant="outlined" fullWidth>
                <Select
                  value={complaintStatus}
                  onChange={(e) => setComplaintStatus(e.target.value)}
                  IconComponent={KeyboardArrowDown}
                >
                  {statusesList.map((status) => (
                    <MenuItem key={status.value} value={status.value}>
                      {status.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              </FormGroup> : ''}
              <FormGroup>
                <FormLabel>Compensation Value</FormLabel>
                <OutlinedInput
                  fullWidth
                  type="number"
                  placeholder="Compensation value"
                  value={compensationValue ?? ""}
                  onChange={(e) => setCompensationValue(e.target.value)}
                />
              </FormGroup>
              <FormGroup>
                <FormLabel>Comment</FormLabel>
                <OutlinedInput
                  fullWidth
                  type="textarea"
                  placeholder="Comment"
                  value={comment ?? ""}
                  multiline={true}
                  rows={5}
                  onChange={(e) => setComment(e.target.value)}
                />
              </FormGroup>
            </form>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setAddModal(false)}>Cancel</Button>
            <Button
              onClick={() =>
                id == null || id === ""
                  ? addComplaintAction()
                  : updateComplaintAction()
              }
              classes={{
                root: classes.buttonContainedPurple100,
              }}
              variant="contained"
            >
              {id == null || id === "" ? "Add" : "Update"}
            </Button>
          </DialogActions>
        </Dialog>
        <Snackbar
          place="tr"
          color="success"
          // icon={AddAlert}
          message={notifMessage}
          open={success}
          closeNotification={() => setSuccess(false)}
          close
        />

        <Snackbar
          place="tr"
          color="rose"
          // icon={AddAlert}
          message={notifMessage}
          open={showError}
          closeNotification={() => setShowError(false)}
          close
        />
      </Container>
    </>
  );
};

export default ComplaintsTable;
